import React from 'react';

interface Props {
  className?: string;
}

const Wind: React.FC<Props> = ({ className = '' }: Props) => (
  <svg
    className={className}
    fill="none"
    height="14"
    viewBox="0 0 16 21"
    width="14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.9882 17.0882L12.0588 8.37451L15.9137 0.5L8.83137 5.66471L0.0862732 6.26078L8.10196 9.81373L12.9882 17.0882ZM10.9176 16.2569L8.40784 12.5235V18.6176H5.58431H4.64314V20.5H5.58431H13.7412H14.6824V18.6176H13.7412H10.9176V16.2569ZM9.66274 7.0098C9.91236 7.0098 10.1518 7.10896 10.3283 7.28547C10.5048 7.46197 10.6039 7.70136 10.6039 7.95098C10.6039 8.2006 10.5048 8.43999 10.3283 8.61649C10.1518 8.793 9.91236 8.89216 9.66274 8.89216C9.41313 8.89216 9.17374 8.793 8.99723 8.61649C8.82073 8.43999 8.72157 8.2006 8.72157 7.95098C8.72157 7.70136 8.82073 7.46197 8.99723 7.28547C9.17374 7.10896 9.41313 7.0098 9.66274 7.0098Z"
      fill="currentColor"
      id="Vector"
    />
  </svg>
);

export default Wind;
